// Apply language changes throughout the application
// This is called when user changes language in settings (prefs.UILanguage.value changes)
NIRV.applyLanguage = function (language) {
  DEBUG && console.log('NIRV.applyLanguage()', language);

  // If no language provided, get from localStorage (single source of truth) or fallback to 'en'
  if (!language) {
    language = NIRV.storage.getItem('i18nextLng') || 'en';
  }

  console.log('🔄 Applying language:', language);

  // Update i18next to match the user's preference
  if (window.NirvanaI18next?.initialized) {
    const currentLang = window.NirvanaI18next.getCurrentLanguage();
    if (currentLang !== language) {
      console.log('🔄 Updating i18next language from', currentLang, 'to', language);
      window.NirvanaI18next.changeLanguage(language);
      NIRV.storage.setItem('i18nextLng', language);
    } else {
      console.log('✅ i18next already using language:', language);
    }
  } else {
    console.warn('⚠️ i18next not ready, cannot apply language:', language);
  }

  // Auto-update date locale to match language
  updateDateLocale(language);

  // Update HTML lang attribute
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language;
  }
};

// Helper function to update date locale based on language
function updateDateLocale(language) {
  if (!NIRV.prefs?.UIDateLocale) return;
  
  const currentDateLocale = NIRV.prefs.UIDateLocale.value;
  let suggestedDateLocale;
  
  switch (language) {
    case 'es': suggestedDateLocale = 'es-ES'; break;
    // case 'fr': suggestedDateLocale = 'fr-FR'; break; 
    // case 'ja': suggestedDateLocale = 'ja-JP'; break;
    case 'en':
    default: suggestedDateLocale = 'en-US'; break;
  }
  
  // Only auto-update if current locale appears to be auto-set
  const isAutoSetLocale = [
    'en-US', 'es-ES', 'fr-FR', 'ja-JP', 'en-GB'
  ].includes(currentDateLocale);
  
  if (isAutoSetLocale && currentDateLocale !== suggestedDateLocale) {
    console.log('📅 Auto-updating date locale from', currentDateLocale, 'to', suggestedDateLocale);
    NIRV.prefs.UIDateLocale.value = suggestedDateLocale;
    if (NIRV.setPref) {
      NIRV.setPref('UIDateLocale', suggestedDateLocale, false);
    }
  }
  
  // Apply jQuery UI datepicker localization
  if (typeof applyDatepickerLocalization === 'function') {
    applyDatepickerLocalization();
  }
}

// Ensure cloud preference is synced to localStorage (called after NIRV.prefs are loaded)
NIRV.ensureLanguagePreferenceSync = function() {
  if (typeof window.syncCloudLanguagePreferenceToLocalStorage === 'function') {
    window.syncCloudLanguagePreferenceToLocalStorage();
    
    // If i18next is already initialized but using different language, sync it
    if (window.NirvanaI18next?.initialized && NIRV.prefs?.UILanguage?.value) {
      const cloudLang = NIRV.prefs.UILanguage.value;
      const currentLang = window.NirvanaI18next.getCurrentLanguage();
      
      if (cloudLang !== currentLang) {
        console.log('🔄 Post-init sync: updating i18next from', currentLang, 'to', cloudLang);
        window.NirvanaI18next.changeLanguage(cloudLang);
      }
    }
  }
};
